import type { Text } from 'mdast';
import type { State } from '../state';
import { trimLines } from 'trim-lines';

/** Turn an mdast `text` node into pm text. */
export function text(state: State, node: Text): void {
	state.addText(trimLines(String(node.value)));
}
